// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AutoLoadingState;
(function (AutoLoadingState) {
    AutoLoadingState[AutoLoadingState["LoadinStarted"] = 0] = "LoadinStarted";
    AutoLoadingState[AutoLoadingState["LoadinFinised"] = 1] = "LoadinFinised";
})(AutoLoadingState || (AutoLoadingState = {}));
